import React from 'react';
import { Icon } from './Icon.js';
export const IconExport = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 15L12 2V3", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M8 6L12 2L16 6", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M7.75879 10H4V20H20V10H16.2363L18.2363 8H22V22H2V8H5.75879L7.75879 10Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconExport.js.map